import * as PIXI from "pixi.js";
import * as React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { SequencerTimeline } from "./SequencerTimeline";
import { UIColors, UIFonts, UIPositioning } from "../Settings/UITheme";
import { VerticalScrollView } from "../Shared/VerticalScrollView";
import NoteHelper from "../../HelperModules/NoteHelper";
import { FAButton } from "../SharedReact/BasicElements";
import { navigationView } from "../Shared/NavigationView";
export class SequencerView extends VerticalScrollView {
    constructor(width, height, track, songManager, startFrom) {
        super(width, height);
        this.timeline = new SequencerTimeline(this._sidebarPosition, width, height, this.contentHeight, songManager, track, startFrom);
        this._sidebarUI = new PIXI.Graphics().beginFill(UIColors.bgColor).drawRect(0, 0, this._sidebarPosition, height).endFill();
        this._sidebarUI.beginFill(UIColors.fgColor)
            .drawRect(0, UIPositioning.timelineHeaderHeight, this._sidebarPosition, 2)
            .drawRect(this._sidebarPosition - 4, 0, 4, height)
            .endFill();
        this._noteList = new SequencerNotes(this._sidebarPosition, width, height, SequencerView.numNotes);
        this.addChild(this._sidebarUI, this._noteList, this.timeline);
        this._backButtonContainer = document.createElement("div");
        Object.assign(this._backButtonContainer.style, {
            position: "absolute",
            top: "5px",
            left: "5px"
        });
        document.getElementById("applicationContainer").appendChild(this._backButtonContainer);
        render(React.createElement(FAButton, { iconName: "fa fa-arrow-left", onClick: () => { navigationView.back(); } }), this._backButtonContainer);
    }
    get contentHeight() {
        return SequencerTimeline.noteHeight * SequencerView.numNotes;
    }
    resize(width, height) {
        super.resize(width, height);
        this._sidebarUI.clear();
        this._sidebarUI.beginFill(UIColors.bgColor).drawRect(0, 0, this._sidebarPosition, height).endFill();
        this._sidebarUI.beginFill(UIColors.fgColor).drawRect(this._sidebarPosition - 4, 0, 4, height).endFill();
        this._noteList.resize(width, height);
    }
    destroy() {
        unmountComponentAtNode(this._backButtonContainer);
        document.getElementById("applicationContainer").removeChild(this._backButtonContainer);
        super.destroy();
    }
    updateVerticalScroll(value) {
        value = Math.min(0, value);
        this.timeline.updateVerticalScroll(value);
        this._noteList.y = value;
    }
}
SequencerView.numNotes = 99;
class SequencerNotes extends PIXI.Container {
    constructor(width, screenWidth, screenHeight, numNotes) {
        super();
        this._numNotes = numNotes - 2;
        this._horizontalLines = new PIXI.Graphics();
        this._horizontalLines.y = UIPositioning.timelineHeaderHeight;
        for (let i = 0; i < this._numNotes; i++) {
            let height = i * SequencerTimeline.noteHeight;
            let text = new PIXI.Text(NoteHelper.noteNumberToNoteString(this._numNotes - 1 - i), UIFonts.trackFont);
            text.x = width / 2 - text.width / 2;
            text.y = UIPositioning.timelineHeaderHeight + height + SequencerTimeline.noteHeight / 2 - text.height / 2 + 1;
            this.addChild(text);
        }
        this.addChild(this._horizontalLines);
        this.resize(screenWidth, screenHeight);
    }
    resize(width, height) {
        this._horizontalLines.beginFill(UIColors.fgColor);
        for (let i = 0; i < this._numNotes; i++) {
            let currentHeight = i * SequencerTimeline.noteHeight;
            this._horizontalLines.drawRect(0, currentHeight, width, 1);
        }
        this._horizontalLines.endFill();
        this.mask = new PIXI.Graphics().beginFill(0xFFFFFF).drawRect(0, UIPositioning.timelineHeaderHeight, width, height).endFill();
    }
}
//# sourceMappingURL=SequencerView.js.map